import { CategoryType } from './../../common/enums';
export class ProductRelationFilterModel {
    public searchTerm: string;
    public isGasInstall: boolean;
    public categoryTypes: Array<CategoryType>;
}